import { ItemList, List } from '../types/main';
import { Item } from '../types/items';

export const transformList = <T extends Item>({
  total_records: totalItems,
  current_page: page,
  page_size: pageSize,
  sort_keys: availableSort,
  sort_key: key,
  sort_dir: dir,
  available_filters: availableFilters,
  selected_filters: active,
  filter_error_str: error,
  permissions,
  data: items,
}: List<T>): ItemList<T> => ({
  pagination: {
    totalItems,
    page,
    pageSize,
  },
  sorting: {
    available: availableSort,
    key,
    dir,
  },
  filters: {
    available: availableFilters,
    active,
    error,
  },
  permissions,
  dirty: false,
  items,
});
